import { useSession } from "../state/session.js";
import { usePendingToggles } from "../ui/usePendingToggles.js";
import { useT } from "../i18n/index.js";
import { Panel } from "../ui/Panel.js";
import { toast } from "../ui/Toast.js";

export const NOTIFICATION_CATEGORIES = ["build", "research", "repair", "attack", "march", "event", "chest", "offer", "vip"] as const;

/** Notification categories (70-events.md R66): switched off here, dropped by the server before the push. */
export function NotificationSettings() {
  const t = useT();
  const settings = useSession((s) => s.settings);
  const updateSettings = useSession((s) => s.updateSettings);
  const toggles = usePendingToggles();
  if (!settings) return null;
  const save = (key: string, on: boolean) => toggles.track(key, on, async () => {
    await updateSettings({ notifications: { ...settings.notifications, [key]: on } });
    toast.success(t("settings.saved"));
  }).catch((e: unknown) => toast.error(e instanceof Error ? e.message : String(e)));
  return (
    <Panel title={t("settings.notifications")}>
      <p className="hint">{t("settings.notifications.hint")}</p>
      <div className="notif-grid" data-testid="notification-settings">
        {NOTIFICATION_CATEGORIES.map((key) => (
          <label key={key} className="row">
            <input type="checkbox" checked={toggles.shown(key, settings.notifications[key] ?? true)} onChange={(e) => void save(key, e.target.checked)} data-testid={`notif-${key}`} />
            {t(`settings.notif.${key}`)}
          </label>
        ))}
      </div>
    </Panel>
  );
}
